import { Editor, Element as SlateElement, Transforms } from 'slate'

import type { SlateAlign } from './types'

export function isAlignActive(editor: Editor, align: SlateAlign): boolean {
  const { selection } = editor
  if (!selection) {
    return false
  }
  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: node => !Editor.isEditor(node) && SlateElement.isElement(node) && node.align === align,
    })
  )
  return match != null
}

export function toggleAlign(editor: Editor, align: SlateAlign): void {
  const active = isAlignActive(editor, align)
  Transforms.setNodes<SlateElement>(editor, {
    align: active ? undefined : align,
  })
}
